import React from 'react';

const moneyFormat = new Intl.NumberFormat('es-MX', {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2
});

const percentageFormat = new Intl.NumberFormat('es-MX', {
    style: 'percent',
    currency: "MXN",
    minimumFractionDigits: 2
});

export const MoneyFormat = ({ value }) => moneyFormat.format(parseFloat(value))

export const TableMoneyFormat = ({ value }) =>

    <td className="text-right font-mini">
        {moneyFormat.format(parseFloat(value))}
    </td>


export const TablePercentageFormat = ({ value, colSpan }) =>

    <td className='text-right' colSpan={colSpan}>
        {percentageFormat.format(parseFloat(value / 100))}
    </td>